<div class="cw-toast-stack" aria-live="polite" aria-relevant="additions">
  @for (toast of toasts(); track toast.id) {
    <div
      class="cw-toast cw-toast--{{ toast.severity }}"
      [class.cw-toast--leaving]="toast.leaving"
      [ngClass]="toast.styleClass"
      role="alert"
    >
      @if (templateFor(toast); as customTemplate) {
        <div class="cw-toast__body">
          <ng-container
            [ngTemplateOutlet]="customTemplate"
            [ngTemplateOutletContext]="{ $implicit: toast, message: toast }"
          ></ng-container>
        </div>
      } @else {
        <span class="cw-toast__icon" aria-hidden="true">
          @switch (toast.severity) {
            @case ('success') {
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path
                  d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.1 14.3-4-4 1.4-1.4 2.6 2.6 5.4-5.4 1.4 1.4-6.8 6.8Z"
                />
              </svg>
            }
            @case ('error') {
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 15h-2v-2h2v2Zm0-4h-2V7h2v6Z" />
              </svg>
            }
            @case ('warn') {
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M1 21h22L12 2 1 21Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z" />
              </svg>
            }
            @default {
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 15h-2v-6h2v6Zm0-8h-2V7h2v2Z" />
              </svg>
            }
          }
        </span>

        <div class="cw-toast__body">
          @if (toast.summary) {
            <span class="cw-toast__summary">{{ toast.summary }}</span>
          }
          @if (toast.detail) {
            <p class="cw-toast__detail">{{ toast.detail }}</p>
          }
        </div>
      }

      @if (toast.closable !== false) {
        <button
          type="button"
          class="cw-toast__close"
          aria-label="Close notification"
          (click)="onClose(toast)"
        >
          <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
            <path
              d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12 19 6.4Z"
            />
          </svg>
        </button>
      }
    </div>
  }
</div>
